"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var warning_1 = __importDefault(require("warning"));

var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));

var Slide_1 = __importDefault(require("./Slide"));

var Snackbar = function Snackbar(props) {
  var ContentProps = props.ContentProps,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom'
  } : _props$anchorOrigin;
  var vertical = _props$anchorOrigin.vertical;
  warning_1.default(ContentProps && ContentProps['aria-describedby'], "Unifi: Snackbar requires an aria-describedby to reference an id placed on the message component, ex: ContentProps={{ 'aria-describedby': 'message-id'}}. For a working, accessible example, see https://unifi.nelnet.io/components/overlays/snackbar");
  var directionProp = vertical === 'top' ? 'down' : 'up';

  function SlideTransition(transitionProps) {
    return React.createElement(Slide_1.default, Object.assign({}, transitionProps, {
      direction: directionProp
    }));
  }

  return React.createElement(Snackbar_1.default, Object.assign({
    TransitionComponent: SlideTransition
  }, props));
};

exports.default = Snackbar;